// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2FzHA","filesListContainer":"PosDisputesFiles_filesListContainer__2iLOA","filesButton":"PosDisputesFiles_filesButton__3EJ83"};